// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5475b1bf","190":"27e65f47","244":"16895c2a","342":"295f4f5a","386":"7d402128","403":"336e8e0d","942":"c96c92dc","981":"e133f835","983":"6d114b05"}[chunkId] + ".chunk.js";
};